import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Label = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  min-width: 20rem;
`;

export const Description = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
`;

export const Anchor = styled.a`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
`;
